import { render, staticRenderFns } from "./bill-manage.vue?vue&type=template&id=f0ab6b08&scoped=true"
import script from "./bill-manage.vue?vue&type=script&lang=js"
export * from "./bill-manage.vue?vue&type=script&lang=js"
import style0 from "./bill-manage.vue?vue&type=style&index=0&id=f0ab6b08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ab6b08",
  null
  
)

export default component.exports